<template>
	<core-layout-headline-with-tabs :tabs="tabs">
		{{ $t("claims") }}
	</core-layout-headline-with-tabs>
</template>

<script>
import CoreLayoutHeadlineWithTabs from "@/modules/core/components/CoreLayoutHeadlineWithTabs"

export default {
	components: { CoreLayoutHeadlineWithTabs },

	computed: {
		tabs() {
			const possibleFields = [
				{
					id: "overview",
					name: this.$t("overview"),
					to: { name: "ClaimDetail", params: { ...this.$route.params } }
				},
				{
					name: this.$t("transactions"),
					to: {
						name: "ClaimTransactions",
						to: {
							name: "ClaimTransactions",
							params: { ...this.$route.params }
						}
					}
				},
				{
					name: this.$t("logs"),
					to: {
						name: "ClaimLogs",
						params: { ...this.$route.params }
					}
				}
			]

			return possibleFields
		}
	}
}
</script>
